import { createAction } from '@reduxjs/toolkit';
import { CALC_ENGINE_ACTION_PREFIX } from '../utilities/constants';

export default createAction(`${CALC_ENGINE_ACTION_PREFIX}/resetAllToggles`);
